(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/league-nhl/assets/javascripts/league.js') >= 0) return;  svs.modules.push('/components/themes/league-nhl/assets/javascripts/league.js'); 
(function(svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.league_nhl = svs.themes.league_nhl || {};

  var logger = new svs.core.log.Logger('svs.themes.league_nhl.league');

  svs.themes.league_nhl.getFormationByPosition = function(params) {
    var players = params && params.players,
      sortedGoalies,
      sortedDefenders,
      sortedAttackers;

    if (players) {
      players = JSON.parse(JSON.stringify(players));
    } else {
      logger.info('No available players.', players);
    }

    if (players && players.uncategorized) {
      players = players.uncategorized;
    }

    sortedGoalies = _.chain(players)
      .where({ position: 'GK' })
      .sortBy(shirtNumber)
      .value();
    sortedDefenders = _.chain(players)
      .where({ position: 'D' })
      .sortBy(shirtNumber)
      .value();
    sortedAttackers = _.chain(players)
      .reject(function(player) {
        return player.position === 'GK' || player.position === 'D';
      })
      .sortBy(shirtNumber)
      .value();

    return {
      goalies: sortedGoalies,
      defenders: sortedDefenders,
      attackers: sortedAttackers
    };

    function shirtNumber(player) {
      if (!player.shirtNumber) {
        return 1000;
      }
      return player.shirtNumber;
    }
  };

  svs.themes.league_nhl.isShowHomeAwayTables = function() {
    return false;
  };
})(svs);

 })(window);